__turbopack_context__.v({
  "manuals": "ManualSectionBlok-module__HMtcQG__manuals",
  "root": "ManualSectionBlok-module__HMtcQG__root",
  "title": "ManualSectionBlok-module__HMtcQG__title",
});
